{
  "MODEL_TOTAL": 192,
  "PROVIDER_TOTAL": 30
}
